module.exports = __webpack_public_path__ + "static/media/_bonaire.3f06ada4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_bonaire.svg
// module id = 2305
// module chunks = 7